import React from "react";
import ManualChemicalVolumeTable from "./component.tsx/ManualChemicalVolumeTable";

const TMManualVolume = () => {
  return <ManualChemicalVolumeTable />;
};

export default TMManualVolume;
